<template>

<v-card flat @click="showOrder" v-bind="$attrs" rounded :dark="dark || isCurrent || show" :color="!isActive ? 'error' : (!isCurrent && !show ? (dark ? 'grey' : 'white') : 'primary')" v-if="isCurrent || isActive">
          <v-list-item v-if="order.code">
           
           <v-list-item-icon class="mr-2">
           <v-icon>closed_caption</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2 pb-0">{{order._host.name}}</v-list-item-title>
              <v-list-item-subtitle class="pl-2 pb-0 do-wrap">Actiecode: {{order.code}}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="order.amount">
                  {{order.amount | toCurrency}}
              </v-list-item-action>
              <v-list-item-action v-if="order.stamps">
                  {{order.stamps}}
              </v-list-item-action>
          </v-list-item>
          <template v-else>
          <v-list-item>
            <v-list-item-action class="mr-2 text-h4" v-if="isCurrent">
                  {{order.number}}
            </v-list-item-action>
            <v-list-item-action v-else class="mr-2">
                 <v-icon v-if="order.deliver">mdi-truck-delivery-outline</v-icon>
                   <v-icon v-else>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="pl-2 pb-0">{{order.name}}</v-list-item-title>
               <v-list-item-subtitle class="pl-2 pb-0 do-wrap" v-if="!isActive">### FOUT BIJ HET BESTELLEN ###</v-list-item-subtitle>
              <v-list-item-subtitle class="pl-2 pb-0 do-wrap" v-if="!isCurrent">{{order.date | moment('dddd D MMMM')}}</v-list-item-subtitle>
              <v-list-item-subtitle class="pl-2 pb-0 do-wrap" v-else-if="order.deliver && order._address">Wordt bezorgd op {{order._address.name}}</v-list-item-subtitle>
              <v-list-item-subtitle class="pl-2 pb-0 do-wrap" v-else-if="order._host._address">Afhalen</v-list-item-subtitle>
            </v-list-item-content>
              <v-list-item-action v-if="!order.deliver && show && order._host._address" @click.stop>
              <a style="text-decoration:none" target="_blank" :href="`https://www.google.com/maps/search/${order._host._address.name}`"><v-icon>mdi-map-marker-outline</v-icon></a>
               </v-list-item-action>
         
            <v-list-item-action v-if="isCurrent">
                <span class="text-h6 my-0">
                 <v-icon v-if="order.deliver" class="mr-2 car-right">mdi-truck-delivery-outline</v-icon>{{order.due | moment('HH:mm')}}</span>
            </v-list-item-action>
            <v-list-item-action v-else-if="!show">
              {{order.amount | toCurrency}}
            </v-list-item-action>
          </v-list-item>
          <v-expand-transition>
            <!--order-detail v-if="show" :value="order" outlined></order-detail-->
            <order-table v-if="show" :value="order" class="ml-2"></order-table>
          </v-expand-transition>
            <v-card-actions v-if="show">
              <v-list-item v-if="order._courier && !order.done">
                  <v-list-item-avatar v-if="order._courier.avatar">
                    <v-img :src="order._courier.avatar"></v-img>
                  </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="text-h6" v-text="order._courier.name">
                        
                      </v-list-item-title>
                      <v-list-item-subtitle>Bezorger</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

              <v-spacer></v-spacer>
              <v-btn v-if="!isCurrent" @click="reOrder" :depressed="!isCurrent" color="primary">Opnieuw bestellen</v-btn>
            </v-card-actions>
          </template>
          <v-divider></v-divider>
        </v-card>
                                            
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import OrderTable from '../components/OrderTable.vue'
import productItem from "@/modules/productItem";
export default {
  mixins: [productItem],
    components: {
    OrderTable
  },
   props: {
    order: {
      type: Object,
      default: function () {
        return null
      },
    },
    dark: {
      type: Boolean,
      default: function () {
        return false
      },
    },
   },
  data: () => ({
     show: false
  }),
  computed: {
    ...mapGetters(["host"]),
    isActive(){
      if (!this.order.payment) return true
      if (['pin','cash'].includes(this.order.payment.type)) return true
      if (['ideal'].includes(this.order.payment.type) && this.order.payment.paid == true) return true
      return false
    },
    isCurrent(){
      if (this.order.done) return false
      return !this.$moment(this.order.date).isBefore(this.$moment(), 'day') 
    }
  },
  mounted () {
   
  },
watch: {

},
methods: {
  ...mapActions(["setHost", "addCartItem","setConfig"]),
  async reOrder(){
    this.$emit('select', this.order)
  },
  showOrder(){
    if (!this.isActive) return this.$router.push({path: this.order._id})
    this.show=!this.show
  }
}
}

</script>
<style>
.car-right {
  position: absolute;
  opacity:1;
  z-index: 10;
  animation-duration: 4s;
  animation-name: goRight;
  animation-iteration-count: 1;
  transform: translate(0,0px);
}

@keyframes goRight {
  1% {
    transform: translate(-400px,30px);
    opacity:0
  }
  99% {
    transform: translate(0px,30px);
    opacity:1
  }
  100% {
    transform: translate(0px,15px);
    opacity:1
  }
}
</style>